import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'
import {
  ListItem
} from 'components/List'
import DraggableUser from '../DraggableUser'
import Avatar from '../Avatar'
import classes from './ListItemUser.module.scss'
import { getFormattedProfileKey } from 'utils/users'

export class ListItemUser extends React.Component {
  static propTypes = {
    size: PropTypes.number,
    subtitle: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    active: PropTypes.bool,

    draggable: PropTypes.bool,
    menu: PropTypes.array,
    presence: PropTypes.number,
    onClick: PropTypes.func,
    onShowProfile: PropTypes.func,

    // User props
    id: PropTypes.number,
    email: PropTypes.string,
    name: PropTypes.string,
    profileKey: PropTypes.string,
    licenseType: PropTypes.number,
    isActive: PropTypes.bool,
    isLoading: PropTypes.bool,
    isLoaded: PropTypes.bool,
    profile: PropTypes.object,

    showProfile: PropTypes.func.isRequired,
  }

  static defaultProps = {
    menu: []
  }

  showProfile = () => {
    const {
      profileKey,
      onShowProfile,
      showProfile
    } = this.props

    showProfile({
      profileKey
    })

    onShowProfile && onShowProfile()
  }

  renderName = () => {
    return this.props.name || <span className={classes.namePlaceholder} />
  }

  renderListItem = (props) => {
    const {
      connectDragSource,
      connectDragPreview,

      size,
      subtitle,
      active,

      draggable,
      menu,
      presence,
      onClick,

      // User props
      id,
      email,
      name,
      profileKey,
      licenseType,
      isActive,
      isLoading,
      isLoaded,
      profile,

      showProfile,

      ...restProps
    } = props

    return (
      <ListItem
        {...restProps}
        ref={ref => {
          if (!draggable) return

          connectDragSource(findDOMNode(ref))
        }}
        draggable={draggable}
        icon={
          <Avatar
            profileKey={profileKey}
            isActive={isActive}
            name={name}
            size={size}
            active={active}
            presence={presence}
          />
        }
        subtitle={subtitle || getFormattedProfileKey(profileKey)}
        active={active}
        menu={menu ? [
          {
            header: true,
            title: name
          },
          ...menu
        ] : null}
        onClick={
          onClick ||
          (menu && this.showProfile)
        }
      >
        {this.renderName()}
      </ListItem>
    )
  }

  render () {
    if (this.props.draggable) {
      return (
        <DraggableUser
          {...this.props}
        >
          {this.renderListItem}
        </DraggableUser>
      )
    } else {
      return this.renderListItem(this.props)
    }
  }
}

export default ListItemUser
